<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "FluxSO",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  